import React from 'react';
import { Redirect } from "react-router-dom";

import { EntitiesArray } from '../components/island';

import Player from '../functions/player';
import API from '../functions/api';

import { finances } from '../actions/financesArray';
import { plots } from '../actions/plotsArray';
import { powerPlants } from '../actions/powerPlantsArray';
import { upgrades } from '../actions/upgradesArray';

export class Timer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      timerOver: false,
      viewActions: this.props.viewActions,
      playSound30sec: false,
      playSound30: false,
      playSoundEnd: false,
    };
    this.handleClick = this.handleClick.bind(this);
    this.endRound = this.endRound.bind(this);
  }

  componentWillMount() {
    this.getTimeUntil(this.props.deadline);
    //console.log('from data', Player.getData('timeLeft'));

    // Check if cookie isset
    let cookie = Player.getCookie('sessionID')
    if (!cookie) {
      this.setState({
        fireRedirect: true
      });
    }
  }

  componentDidMount() {
    var t = setInterval(
      () => this.getTimeUntil(this.props.deadline),
      1000
    );
    this.setState({intervalId: t});

    this.saveSession();

    // Every X seconds resend the data to api
    var t2 = setInterval(() => {
      let sessionCode = Player.getCookie('sessionID');
      let data = EntitiesArray;
      let roundNumber = Player.getData('round');

      const shouldUpdate = Player.getData('sessionWasRestored');

      if(data && shouldUpdate) {
        // Send a POST request
        API.post('/?action=updateSession', {
          code: sessionCode,
          elapsed: {
            minutes: this.state.minutes,
            seconds: this.state.seconds,
            round: roundNumber,
            route: this.props.getGameScreen(),
            part: this.props.part,
          },
          json: data,
          finances: finances,
          plots: plots,
          powerPlants: powerPlants,
          upgrades: upgrades,
        })
        .catch(function (error) {
          console.log(error);
        });
      } else {
        console.log('No known data', data);
      }

    }, 10000);

    this.setState({updateIntervalId: t2});
  }

  saveSession = () => {
    let sessionCode = Player.getCookie('sessionID');
    let data = EntitiesArray;
    let roundNumber = Player.getData('round');

    const shouldUpdate = Player.getData('sessionWasRestored');

    if(data && shouldUpdate) {
      // Send a POST request
      API.post('/?action=updateSession', {
        code: sessionCode,
        elapsed: {
          minutes: this.state.minutes,
          seconds: this.state.seconds,
          round: roundNumber,
          route: this.props.getGameScreen(),
          part: this.props.part,
        },
        json: data,
        finances: finances,
        plots: plots,
        powerPlants: powerPlants,
        upgrades: upgrades,
      })
      .catch(function (error) {
        console.log(error);
      });
    }
  }

  instantUpdate = () => {
    let sessionCode = Player.getCookie('sessionID');
    let data = EntitiesArray;
    let roundNumber = Player.getData('round');

    if(data) {
      // Send a POST request
      API.post('/?action=updateSession', {
        code: sessionCode,
        elapsed: {
          minutes: this.state.minutes,
          seconds: this.state.seconds,
          round: roundNumber,
          route: this.props.getGameScreen(),
          part: this.props.part,
        },
        json: data,
        finances: finances,
        plots: plots,
        powerPlants: powerPlants,
        upgrades: upgrades,
      })
      .catch(function (error) {
        console.log(error);
      });
    }
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
    clearInterval(this.state.updateIntervalId);
  }

  endRound() {
    this.setState({
      timerOver: true,
    })
  }

  leading0(num) {
    return num < 10 ? '0' + num : num;
  }

  getTimeUntil(deadline) {
    const time = Date.parse(deadline) - Date.parse(new Date());
    const currentLocation = Player.getData('localRoute');
    if (currentLocation === '/game') {
      if (time === 32000) {
        this.setState({
          playSound30: true,
        })
      }
      if (time <= 30000) {
        this.setState({
          playSound30sec: true,
        })
      }
      if (time <= 2000) {
        this.setState({
          playSound30sec: false,
          playSoundEnd: true,
        })
      }
    }

    if(time < 0) {
      this.setState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        timerOver: true,
      });
      clearInterval(this.state.intervalId);

      let sessionCode = Player.getCookie('sessionID');
      let data = EntitiesArray;
      let roundNumber = Player.getData('round');

      // Send a POST request
      API.post('/?action=updateSession', {
        code: sessionCode,
        elapsed: {
          minutes: this.state.minutes,
          seconds: this.state.seconds,
          round: roundNumber,
          route: this.props.getGameScreen(),
          part: this.props.part,
        },
        json: data,
        finances: finances,
        plots: plots,
        powerPlants: powerPlants,
        upgrades: upgrades,
      })
      .catch(function (error) {
        console.log(error);
      });
    } else {

      const seconds = Math.floor((time/1000)%60);
      const minutes = Math.floor((time/1000/60)%60);
      const hours = Math.floor((time/(1000*60*60))%24);
      const days = Math.floor(time/(1000*60*60*24));

      this.setState({ days, hours, minutes, seconds });
      //console.log(this.state.timerOver);
    }
  }

  // Click event handler when skipping round in at game
  handleClick = () => {
    let sessionCode = Player.getCookie('sessionID');
    let data = EntitiesArray;
    let roundNumber = Player.getData('round');

    const route = Player.getData('localRoute');

    if (route !== '/roundswitch') {
      // Send a POST request
      API.post('/?action=updateSession', {
        code: sessionCode,
        elapsed: {
          minutes: this.state.minutes,
          seconds: this.state.seconds,
          round: roundNumber,
          route: this.props.getGameScreen(),
          part: this.props.part,
        },
        json: data,
        finances: finances,
        plots: plots,
        powerPlants: powerPlants,
        upgrades: upgrades,
      })
      .catch(function (error) {
        console.log(error);
      });
    }
    this.setState({
      timerOver: true,
    })
  }

  killSession = () => {
    Player.eraseCookie('sessionID');
    this.setState({
      fireRedirect: true,
    })
    window.location.reload(true);
  }

  componentWillUpdate() {
    Player.storeData('timeLeft', [this.state.minutes, this.state.seconds]);
  }

  renderActions(showCondition){
    if(showCondition){
      return (<div className="gameActions">
        <a onClick={ () => this.handleClick() }><img className="game-skip" alt='Sla ronde over' src={require("../assets/elements/Icon-skip.svg")}/></a>
        <a onClick={ () => this.killSession() }><img className="game-stop" alt='Stop game' src={require("../assets/elements/Icon-stop.svg")}/></a>
      </div>);
    }
  }

  render() {
    return(
      <div className="gameControl">
        <div className="gameTimer">
          <span className="clock">{this.leading0(this.state.minutes)} : {this.leading0(this.state.seconds)}</span>
          {this.state.timerOver && (Player.getNextRedirect())}
          {this.state.fireRedirect && (<Redirect to="/"/>)}
          {this.state.playSound30sec && (<audio loop autoPlay> <source src={require("../assets/30sec_single_bieb.mp3")} type="audio/mpeg"/> </audio>)}
          {this.state.playSound30 && (<audio autoPlay> <source src={require("../assets/30secleft.mp3")} type="audio/mpeg"/> </audio>)}
          {this.state.playSoundEnd && (<audio autoPlay> <source src={require("../assets/endround.mp3")} type="audio/mpeg"/> </audio>)}
        </div>
        {this.renderActions(this.state.viewActions)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/timer.js